"use client";

import MemoryGraphDemo from "../../demo/MemoryGraphDemo";

export default function MemoryDemo() {
  return (
    <div className="h-80 w-full">
      <MemoryGraphDemo />
    </div>
  );
}
